const API_BACKEND = process.env.REACT_APP_API_BACKEND;

export const getCurrency = async () => {
    try {
        const res = await fetch(`${API_BACKEND}api/v1/business/getCountryCodePhoneCode`);
        const data = await res.json();
        // console.log(data?.result, "<<<===currencydata")

        if (data?.result?.countryCode === "IN") {
            return { currencySymbol: "₹", currencyName: "Rupees" };
        } else if (data?.result?.countryCode === "AE") {
            return { currencySymbol: "AED ", currencyName: "Dirhams" };
        } else {
            return { currencySymbol: "₹", currencyName: "Rupees" };
        }
    } catch (err) {
        console.error(err);
        return { currencySymbol: "₹", currencyName: "Rupees" };
    }
};
